/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisconnectedEntityLicenseOfferResponse } from './disconnectedEntityLicenseOfferResponse';


export interface DisconnectedEntityLicenseOfferBulkResponse { 
    disconnected_license_offers?: Array<DisconnectedEntityLicenseOfferResponse>;
    total_record_count?: number;
}

